<div class="detail-overview-surveys">
  <div class="row">
    <ng-container
      *ngFor="let evaluation of evaluations | keyvalue; let i = index"
    >
      <div class="col-lg-6 col-md-12">
        <div class="round-box m-1">
          <div class="title">
            <span class="icon">
              <img src="assets/icons/icon-overview-{{ i }}.svg"
            /></span>
            <span class="titleTile">
              {{ evaluation["value"]["titleTile"] }}</span
            >
          </div>
          <div class="evaluation-nb">
            <div
              class="eval-nb-title"
              i18n="@@patients_evaluationOverviewSurveys_nbEvaluation"
            >
              Nb d’évaluation sur les 12 derniers mois
            </div>
            <div
              class="nb-eval"
              *ngIf="
                evaluation['value']['features'][0]['featureId'] !==
                  'sf36-physical_health-scr' &&
                evaluation['value']['features'][0]['featureId'] !==
                  'sf36-mental_health-scr'
              "
            >
              {{ evaluation["value"]["features"][0]["numberTotalEval"] }}
            </div>
            <div
              class="nb-eval"
              *ngIf="
                evaluation['value']['features'][0]['featureId'] ===
                'sf36-physical_health-scr'
              "
            >
              {{
                evaluation["value"]["features"][0]["numberTotalEval"] >=
                evaluation["value"]["features"][1]["numberTotalEval"]
                  ? evaluation["value"]["features"][0]["numberTotalEval"]
                  : evaluation["value"]["features"][1]["numberTotalEval"]
              }}
            </div>
          </div>

          <button
            type="button"
            class="btn-more rounded-5 btn"
            (click)="sendCodeToOverview(evaluation['value']['evaluationCode'])"
          >
            <span i18n="@@patients_evaluationOverviewSurveys_seeMore"
              >Voir plus</span
            >
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
